import { IssueSingleItem } from '@finance-lab/utils/types'

const issueTypeBasedLabels = {
    offeredUnits: {
        'Rights issue': 'Antal units',
        IPO: 'Antal units',
        'ABB Directed issue': 'Cirka antal aktier',
        '*': 'Antal aktier',
    },
    unitSubPrice: {
        'ABB Directed issue': 'Pris per aktie',
        'Directed issue': 'Pris per aktie',
        'Non-cash issue': 'Pris per aktie',
        'Guarantor fee issue': 'Pris per aktie',
        '*': 'Pris per unit',
    },
    unitsReceived: {
        'ABB Directed issue': 'Antal aktier',
        'Directed issue': 'Antal aktier',
        'Non-cash issue': 'Antal aktier',
        'Guarantor fee issue': 'Antal aktier',
        '*': 'Antal units',
    },
    unitSubTotal: {
        'ABB Directed issue': 'Aktier tecknade',
        'Directed issue': 'Aktier tecknade',
        'Non-cash issue': 'Aktier tecknade',
        'Guarantor fee issue': 'Aktier tecknade',
        '*': 'Units tecknade',
    },
    ipoIntervalLow: {
        '*': 'Pris per unit lägsta',
    },
    ipoIntervalHigh: {
        '*': 'Pris per unit högsta',
    },
} as const

/**
 * Returns a label for a field on those cases where the label depends on some data in the issue (generally, the issue type).
 *
 * @param {*} fieldName the name of the field
 * @param {*} issue the issue object
 */
export const variableLabel = (fieldName: keyof typeof issueTypeBasedLabels, issue: Pick<IssueSingleItem, 'type'>) => {
    if (!issue?.type) return fieldName
    const typeBasedLabels = issueTypeBasedLabels[fieldName]
    if (!typeBasedLabels) return fieldName

    const issueType = issue.type
    if (issueType in typeBasedLabels) {
        return typeBasedLabels[issueType as keyof typeof typeBasedLabels]
    }

    return typeBasedLabels['*'] || fieldName
}
